import type { ReactNode } from "react";
import { Toggle } from "@elaniintc/goes-design-system";
import { cn } from "@/utils/theme";

export interface MenuBarItemProps {
  type: "first" | "last" | "single" | undefined;
  isPressed: boolean;
  onClick: () => boolean;
  icon: ReactNode;
  isDisabled?: boolean;
}
function MenuBarItem({
  type,
  isPressed,
  onClick,
  icon,
  isDisabled = false,
}: MenuBarItemProps) {
  return (
    <Toggle
      type="button"
      pressed={isPressed}
      onPressedChange={onClick}
      disabled={isDisabled}
      className={cn(
        "rounded-none hover:bg-neutral-object-accent-silent  data-[state=on]:bg-neutral-object-accent border-r border-t border-b border-neutral px-2 py-1 text-sm cursor-pointer",
        {
          "rounded-l-md border-l": type === "first" || type === "single",
          "rounded-r-md": type === "last" || type === "single",
          "bg-transparent cursor-pointer": !isDisabled,
          "cursor-not-allowed bg-neutral-object-accent-silent text-on-disabled":
            isDisabled,
        },
      )}
    >
      {icon}
    </Toggle>
  );
}

export default MenuBarItem;
